<app-form-array-table
  [formArray]="formControls()"
  [canAdd]="canAdd()"
  (add)="createNewFileGroup.emit()"
>
  <ng-template #headers>
    <th class="col-main-input">
      {{
        "registrationWizard.investmentQualificationTest.knowledgeTestForm.netIncome"
          | translate
      }}
    </th>
    <th class="col-secondary-input">
      <div class="check-input-container">
        {{
          "registrationWizard.investmentQualificationTest.knowledgeTestForm.regularIncome"
            | translate
        }}
      </div>
    </th>
    <th class="col-action"></th>
  </ng-template>

  <ng-template #row let-formGroup let-index="index">
    <ng-container [formGroup]="formGroup">
      <td class="col-main-input">
        <app-validated-currency-input
          label="registrationWizard.investmentQualificationTest.knowledgeTestForm.netIncome"
          [inputFormControlName]="'netIncome'"
          [inputFormControl]="formGroup.controls['netIncome']"
          [leaveSpaceForValidation]="true"
          [omitKeydownEnter]="true"
          [currencyCode]="currencyCode()"
          class="w-100"
        >
        </app-validated-currency-input>
      </td>

      <td class="col-secondary-input">
        <div
          class="input-container d-flex justify-content-center align-items-center h-100"
        >
          <input
            class="form-check-input check-input"
            type="checkbox"
            formControlName="regularIncome"
            (keydown.enter)="onEnterKey($event)"
          />
        </div>
      </td>

      <td class="col-action">
        <div
          class="input-container d-flex justify-content-center align-items-center h-100"
        >
          <div class="action">
            <span
              class="far fa-trash-alt text-primary"
              style="cursor: pointer"
              title="Delete Row"
            ></span>
          </div>
        </div>
      </td>
    </ng-container>
  </ng-template>
</app-form-array-table>
